var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-solid 1",
    clipPath: "url(#clip0_11_55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.82666 1.65038C9.0915 1.38476 9.04931 0.990225 8.73056 0.769522C8.41181 0.548819 7.93838 0.583975 7.67353 0.8496L4.5001 4.02343L1.32666 0.8496C1.06181 0.583975 0.588377 0.548819 0.269626 0.769522C-0.0491235 0.990225 -0.091311 1.38476 0.173533 1.65038L3.52275 4.99999L0.173533 8.3496C-0.091311 8.61523 -0.0491235 9.00976 0.269626 9.23046C0.588377 9.45116 1.06181 9.41601 1.32666 9.15038L4.5001 5.97655L7.67353 9.15038C7.93838 9.41601 8.41181 9.45116 8.73056 9.23046C9.04931 9.00976 9.0915 8.61523 8.82666 8.3496L5.47744 4.99999L8.82666 1.65038Z",
    fill: "#0072CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.38a20a2871692b80f1e1629ec19c80bc.svg";
export { ForwardRef as ReactComponent };